import { getAllProfessionalApi } from 'Constants';
import { Context } from 'Context/Context';
import CompleteClientUserDetails from 'Modals/CompleteClientUserDetails';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import TimeframeHeader from './TimeframeHeader';
import { DataTable, Pagination, ExportMenu, FilterRow, ResultCount, downloadRows, cell } from './AdminAnalyticsUI';

const PAGE_SIZE = 20;
const fullName = (u) => [u.firstName, u.lastName].filter(Boolean).join(' ');

function ClientUserAnalytics() {
    const {makeApiCallFunc} = useContext(Context);
    const [profData, setProfData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [loadList, setLoadList] = useState(false);
    const [dateRange, setDateRange] = useState([{ startDate: '', endDate: '', key: 'selection' }]);
    const [frame, setFrame] = useState("all");
    const [currentClient, setCurrentClient] = useState({});
    const [skip, setSkip] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [exporting, setExporting] = useState(false);

    const dateFilter = () => {
      const startTime = dateRange[0]?.startDate ? dateRange[0].startDate : null;
      const endTime = dateRange[0]?.endDate ? dateRange[0].endDate : null;
      return startTime === null ? {} : { startTime, endTime };
    };

    useEffect(() => {
      window.scrollTo(0,0);
      setLoading(true);
      makeApiCallFunc(getAllProfessionalApi,
        { role: 1, ...dateFilter(), skip, limit: PAGE_SIZE },
        ({data})=> {
          setProfData(data?.modifiedResponse || []);
          setTotalCount(data?.totalCount || 0);
          setLoading(false);
        },
        (data) => { console.log(data); setLoading(false); }
      )
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[loadList, skip]);

    const rows = (profData || []).map((r, i) => ({ ...r, _idx: skip + i + 1 }));
    const page = Math.floor(skip / PAGE_SIZE) + 1;
    const totalPages = Math.max(1, Math.ceil(totalCount / PAGE_SIZE));

    const columns = [
      { label: '#', width: '44px', sortVal: (r) => r._idx, render: (r) => <span style={cell.index}>{r._idx}</span> },
      { label: 'Name', width: 'minmax(0,1.3fr)', sortVal: (r) => fullName(r).toLowerCase(), render: (r) => <div className='truncate' style={cell.primary}>{fullName(r) || '—'}</div> },
      { label: 'Email', width: 'minmax(0,1.6fr)', sortVal: (r) => (r.email || '').toLowerCase(), render: (r) => <div className='truncate' style={cell.muted}>{r.email || '—'}</div> },
      { label: 'Phone', width: '130px', sortVal: (r) => r.phoneNumber || '', render: (r) => <span style={r.phoneNumber ? cell.muted : cell.empty}>{r.phoneNumber || '—'}</span> },
      { label: 'Logins', width: '80px', right: true, sortVal: (r) => parseInt(r.totalLoginCount) || 0, render: (r) => { const v = parseInt(r.totalLoginCount) || 0; return <span style={cell.num(v)}>{v}</span>; } },
      { label: 'Joined on', width: '100px', sortVal: (r) => new Date(r.timestamp || 0).getTime(), render: (r) => <span style={r.timestamp ? cell.date : cell.empty}>{r.timestamp ? moment(r.timestamp).format('MM/DD/YYYY') : '—'}</span> },
    ];

    const doExport = (format) => {
      setExporting(true);
      makeApiCallFunc(getAllProfessionalApi,
        { role: 1, ...dateFilter(), skip: 0, limit: Math.max(totalCount, 1) },
        async ({data}) => {
          try {
            const all = data?.modifiedResponse || [];
            const out = [
              ['#', 'Name', 'Email', 'Phone', 'Successful logins', 'Joined on'],
              ...all.map((r, i) => [i + 1, fullName(r), r.email || '', r.phoneNumber || '', parseInt(r.totalLoginCount) || 0, r.timestamp ? moment(r.timestamp).format('MM/DD/YYYY') : '']),
            ];
            await downloadRows(out, format, 'QCR_clients' + (frame !== 'all' ? '_' + frame : '') + '_' + moment().format('YYYY-MM-DD'));
          } catch (e) { console.log(e); toast.error('Export failed. Please try again.'); }
          setExporting(false);
        },
        (e) => { console.log(e); toast.error('Export failed. Please try again.'); setExporting(false); }
      );
    };

  return (
    <div className='w-full font-plexsans'>
      {
        showModal &&
        <CompleteClientUserDetails uploadNew={showModal} onClose={()=> setShowModal(false)} userData={currentClient}/>
      }
      <FilterRow
        label="Joined on"
        control={
          <TimeframeHeader
            className='flex items-center'
            showAll={true}
            setPaginateLimit={() => setSkip(0)}
            setLoadCaseAnalytics={setLoadList} frame={frame} setFrame={setFrame} setDateRange={setDateRange} dateRange={dateRange}/>
        }
        right={<ExportMenu onExport={doExport} exporting={exporting} />}
      />
      <ResultCount from={totalCount === 0 ? 0 : skip + 1} to={Math.min(skip + PAGE_SIZE, totalCount)} total={totalCount} noun="clients" />
      <DataTable
        key={skip + '-' + frame}
        columns={columns}
        rows={rows}
        loading={loading}
        minWidth={720}
        emptyText="No clients match these filters"
        onRowClick={(r) => { setCurrentClient(r); setShowModal(true); }}
        footer={!loading && totalCount > 0 && <Pagination page={page} totalPages={totalPages} onPage={(p) => { if (p >= 1 && p <= totalPages) setSkip((p - 1) * PAGE_SIZE); }} />}
      />
    </div>
  )
}

export default ClientUserAnalytics
